import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { createGtag } from 'vue-gtag'

const app = createApp(App)

app.use(createPinia())
app.use(router)

// Configure Google Analytics
app.use(
  createGtag({
    tagId: 'G-Q6VBKVCX8Q',
    pageTracker: {
      router
    }
  })
)

app.mount('#app')
